import React from 'react'
import Header from './Header.jsx'
import ProductPage from '../pages/ProductPage.jsx'

const Root = () => {
  return (
    <div>
        <Header/>
        <ProductPage/>
    </div>
  )
}

export default Root
